import { combineReducers } from 'redux'
import {
	actsLogsSlice,
	bgEventsLogsSlice,
	bgEventsAstLogsSlice,
	bgEventsRequestStatusSlice,
	changeStatusErrorsSlice,
	customerIdentificationSlice,
	knowledgeLogsSlice,
	newOrdersLogsSlice,
	onlineOrdersLogsSlice,
	ordersLogsSlice,
	partnersLogsSlice,
	rbidosRequestsLogsSlice,
	reportsLogsSlice,
	reserveAccountsLogsSlice,
	sberCrmLogsSlice,
	smsRulesLogsSlice,
	statusesLogsSlice,
	usersLogsSlice,
	qaRequestsLogsSlice,
	ordersApiLogsSlice,
	apiRequestsLogsSlice,
	integrationChannelLogsSlice,
	externalRequestsLogsSlice,
	departmentsLogsSlice,
	preRecordSlice,
	bprofileLogsSlice,
	blankRegistrationDateLogsSlice,
} from 'Pages/logs'

export const logs = combineReducers({
	[actsLogsSlice.name]: actsLogsSlice.reducer,
	[bgEventsLogsSlice.name]: bgEventsLogsSlice.reducer,
	[bgEventsAstLogsSlice.name]: bgEventsAstLogsSlice.reducer,
	[bgEventsRequestStatusSlice.name]: bgEventsRequestStatusSlice.reducer,
	[changeStatusErrorsSlice.name]: changeStatusErrorsSlice.reducer,
	[customerIdentificationSlice.name]: customerIdentificationSlice.reducer,
	[knowledgeLogsSlice.name]: knowledgeLogsSlice.reducer,
	[newOrdersLogsSlice.name]: newOrdersLogsSlice.reducer,
	[onlineOrdersLogsSlice.name]: onlineOrdersLogsSlice.reducer,
	[ordersLogsSlice.name]: ordersLogsSlice.reducer,
	[partnersLogsSlice.name]: partnersLogsSlice.reducer,
	[rbidosRequestsLogsSlice.name]: rbidosRequestsLogsSlice.reducer,
	[reportsLogsSlice.name]: reportsLogsSlice.reducer,
	[reserveAccountsLogsSlice.name]: reserveAccountsLogsSlice.reducer,
	[sberCrmLogsSlice.name]: sberCrmLogsSlice.reducer,
	[smsRulesLogsSlice.name]: smsRulesLogsSlice.reducer,
	[statusesLogsSlice.name]: statusesLogsSlice.reducer,
	[usersLogsSlice.name]: usersLogsSlice.reducer,
	[qaRequestsLogsSlice.name]: qaRequestsLogsSlice.reducer,
	[ordersApiLogsSlice.name]: ordersApiLogsSlice.reducer,
	[apiRequestsLogsSlice.name]: apiRequestsLogsSlice.reducer,
	[integrationChannelLogsSlice.name]: integrationChannelLogsSlice.reducer,
	[externalRequestsLogsSlice.name]: externalRequestsLogsSlice.reducer,
	[departmentsLogsSlice.name]: departmentsLogsSlice.reducer,
	[preRecordSlice.name]: preRecordSlice.reducer,
	[bprofileLogsSlice.name]: bprofileLogsSlice.reducer,
	[blankRegistrationDateLogsSlice.name]: blankRegistrationDateLogsSlice.reducer,
})
